module.exports = __webpack_public_path__ + "static/media/golf-outing-background.bf3454f6.jpg";